export default "__VITE_ASSET__f528112b__"